import { Component } from '@angular/core';
import { MenuItemComponent } from "./menu-item/menu-item.component";
import { CommonModule } from '@angular/common';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { MenuService } from 'src/app/services/menu/menu.service';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { LanguageService } from 'src/app/services/language/language.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorComponent } from "../../layout/error/error.component";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenuModalComponent } from './menu-modal/menu-modal.component';





@Component({
  selector: 'app-menu-manager',
  imports: [MenuItemComponent, CommonModule, DragDropModule, FormsModule, SpinnerComponent, ErrorComponent],
  templateUrl: './menu-manager.component.html',
  styleUrl: './menu-manager.component.css'
})
export class MenuManagerComponent {

  menuItems: any
  load = false
  loadSave = false

  error = false

  isDrangDrop = false

  currentLang = 'geo'

  constructor(
    private MenuService: MenuService, 
    private langService: LanguageService,
    private ToastrService: ToastrService,
    private modalService: NgbModal
  ){

    this.currentLang = this.langService.getLanguage();

    this.langService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang;
        this.getMenu()
    });

    this.getMenu()

  }

  getMenu(){
    this.load = true
    this.MenuService.getMenu().subscribe(
      (res: any) => {
        console.log(res)
        this.load = false
        this.menuItems = res.data;
        // console.log(this.menuItems)
        this.error = false
      },
      (error: any) => {
        this.error = true
        this.load = false
      }
    );
  }

  onMenuChange(){
    this.getMenu();
  }

  getPayload(items: any[]): any[] {
    return items.map(item => ({
      id: item.id,
      sort: item.sort,
      children: item.children?.length ? this.getPayload(item.children) : []
    }));
  }


  save() {
    this.loadSave = true;

  // Prepare payload for main items and their children
  // const payload = this.menuItems.map((item: any, index: number) => ({
  //   id: item.id,
  //   sort: index + 1,
  //   children: item.children?.map((child: any, childIndex: number) => ({
  //     id: child.id,
  //     sort: childIndex + 1
  //   })) || []
  // }));
    const payload = this.getPayload(this.menuItems);


    this.MenuService.updateSort(payload).subscribe(
      () => {
        this.loadSave = false;
        this.ToastrService.success('შენახულია!');
        this.isDrangDrop = false;
      },
      () => {
        this.loadSave = false;
        this.ToastrService.error('შეცდომა!');
      }
    );
  }

  prepareItem(item: any, index: number) {
    return {
      id: item.id,
      order: index,
      menutitle: item.menutitle,
      visibility: item.visibility ? 1 : 0,
      children: item.children?.map((child: any, childIndex: number) => ({
        id: child.id,
        order: childIndex,
        title: child.title,
        visibility: child.visibility ? 1 : 0,
      })) || [],
    };
  }

  drop(event: CdkDragDrop<any[]>) {
    // console.log('From:', event.previousIndex, 'To:', event.currentIndex);
    // console.log('Before:', JSON.parse(JSON.stringify(this.menuItems)));
    moveItemInArray(this.menuItems, event.previousIndex, event.currentIndex);
    this.menuItems.forEach((item: any, index: number) => {
      item.order = index;
    });
    this.menuItems.sort((a: any, b: any) => a.order - b.order);
    // console.log('After:', this.menuItems);
    this.isDrangDrop = true
  }

    trackById(index: number, item: any): number {
      return item.id;
    }

    onUpdate(){

    }

  openAddModal() {
    const modalRef = this.modalService.open(MenuModalComponent, { size: 'lg' });
    modalRef.componentInstance.menuItem = { menutitle: '', visibility: 1 };

    modalRef.result
      .then((result: any) => {
        if (result) {
          const newItem = {
            id: null as number | null,
            menutitle: result.title,
            visibility: result.visibility,
            children: [] as any[],
            order: this.menuItems.length
          };
          this.menuItems.push(newItem);
          this.isDrangDrop = true;
        }
      })
      .catch(() => {});
  }

  

}
